import { render } from "./OcrList.vue?vue&type=template&id=397a5452"
import script from "./OcrList.vue?vue&type=script&lang=js"
export * from "./OcrList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__